/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import SuperUserService from "../SuperUserService";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { parseStringToInt } from "../lib/utils";
import bankData from "../lib/banks.json";

export function useBankData() {
  const [loadingBanks, setLoadingBanks] = useState(false);
  const [banks, setBanks] = useState([]);

  const sortBanks = (bankData) => {
    if (!bankData) {
      return [{ name: "No banks", code: "", id: "hes" }];
    }
    const transformed = bankData
      .sort(function (a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      })
      .map((data) => ({
        ...data,
        label: data.name,
        value: data.code,
      }));

    return transformed;
  };

  useEffect(() => {
    setBanks(sortBanks(bankData.data));
  }, []);

  return {
    banks,
    loadingBanks,
  };
}
export default function useAddForm() {
  const navigate = useNavigate();
  const [loanAmount, setLoanAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [refferedBy, setRefferedBy] = useState("");
  const [loanTenure, setLoanTenure] = useState(12);

  const handleSetLoanAmount = (e) => {
    setLoanAmount(e.target.value);
  };
  const [applicantData, setApplicantData] = useState({
    name: "",
    first_name: "",
    surname: "",
    nin: "",
    lga: "",
    phone: "",
    sex: "",
    age: "",
    dob: "",
  });
  const handleSetApplicantData = (e) => {
    setApplicantData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [bankDetails, setBankDetails] = useState({
    bank: "",
    bank_code: "",
    account_number: "",
  });
  const handleSetBankDetails = (e) => {
    setBankDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [institutionData, setInstitutionData] = useState({
    name: "",
    course: "",
    current_study_year: "",
    faculty: "",
    other_name: "",
  });
  const handleSetInstitutiontData = (e) => {
    setInstitutionData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSetInstitutionName = (value) => {
    setInstitutionData((prev) => ({
      ...prev,
      name: value,
    }));
  };
  const handleSetFirstGuarantorData = (e) => {
    setFirstGuarantorData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [secondGuarantorData, setSecondGuarantorData] = useState({
    name: "",
    work_place: "",
    nin: "",
    phone: "",
  });
  const handleSetSecondGuarantorData = (e) => {
    setSecondGuarantorData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const [firstGuarantorData, setFirstGuarantorData] = useState({
    name: "",
    work_place: "",
    nin: "",
    phone: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const [_, error] = await SuperUserService.addLoan({
      institutionData: {
        ...institutionData,
        name:
          institutionData.name.toLowerCase() == "others"
            ? institutionData.other_name
            : institutionData.name,
      },
      bankDetails,
      loanAmount,
      loanTenure,
      refferedBy,
      monthly_repayment_amount:
        parseFloat(loanAmount) / parseStringToInt(loanTenure, 12),
      applicantData: {
        ...applicantData,
        name: `${applicantData.first_name} ${applicantData.surname}`,
      },
      guarantorDetails: {
        first: firstGuarantorData,
        second: secondGuarantorData,
      },
    });
    setLoading(false);
    if (!error) {
      setApplicantData({
        name: "",
        lga: "",
        phone: "",
        sex: "",
        age: "",
        nin: "",
      });
      setBankDetails({ bank: "", bank_code: "", account_number: "" });
      setFirstGuarantorData({ name: "", work_place: "", phone: "", nin: "" });
      setInstitutionData({
        name: "",
        course: "",
        current_study_year: "",
        faculty: "",
      });
      setSecondGuarantorData({ name: "", work_place: "", phone: "", nin: "" });
      setLoanAmount("");
      navigate("/superuser");
      return message.success("Loan Added Successfully");
    }
    return message.error(error.message || "Sorry could not add Loan");
  };

  return {
    applicantData,
    handleSetApplicantData,
    institutionData,
    handleSetInstitutiontData,
    bankDetails,
    handleSetBankDetails,
    firstGuarantorData,
    handleSetFirstGuarantorData,
    secondGuarantorData,
    handleSetSecondGuarantorData,
    loanAmount,
    handleSetLoanAmount,
    loading,
    setBankDetails,
    refferedBy,
    setRefferedBy,
    handleSubmit,
    handleSetInstitutionName,
    loanTenure,
    setLoanTenure,
  };
}
